/*eslint-disable */
<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card :class="{ 'remove_card': propOpenedInModal }">
          <template v-slot:headerTitle v-if="!propOpenedInModal">
            <h4 class="card-title">
              {{ cvCardTitle }}
            </h4>
          </template>
          <template>
            <form action="#">
              <div class="form-row">
                <div class="col-md-12 mb-3">
                  <label
                    for="validationuser_name">
                    {{cvNameLabel}}</label>
                  <input
                    v-model="vmSubscriptionFormData.user_name"
                    type="text"
                    class="form-control"
                    required/>
                </div>
                <div class="col-md-12 mb-3">
                  <label
                    for="validationemail">
                    {{cvEmailLabel}}</label>
                  <input
                    v-model="vmSubscriptionFormData.user_email"
                    type="text"
                    class="form-control"
                    required/>
                </div>
                <div class="col-md-12 mb-3">
                  <label
                    for="validationmobile">
                    {{cvSubsMobileLabel}}</label>
                  <input
                    v-model="vmSubscriptionFormData.user_mobile"
                    type="text"
                    class="form-control"
                    required/>
                </div>
                <div class="col-md-12 mb-3">
                  <label
                    for="validationsubs_trial_end">
                    {{cvPaytidLabel}}</label>
                  <input
                    v-model="vmSubscriptionFormData.subs_tid"
                    type="text"
                    class="form-control"
                    required/>
                </div>
                <div class="col-md-12 mb-3">
                  <label
                    for="validationorder_id">
                    {{cvOrderIdLabel}}</label>
                  <input
                    v-model="vmSubscriptionFormData.order_id"
                    type="text"
                    class="form-control"
                    required/>
                </div><div class="col-md-12 mb-3">
                  <label
                    for="validationparent_name">
                    {{cvParentNameLabel}}</label>
                  <input
                    v-model="vmSubscriptionFormData.parent_name"
                    type="text"
                    class="form-control"
                    required/>
                </div>
                <div class="col-md-12 mb-3">
                  <label
                    for="validationparent_mobile">
                    {{cvParentmobileLabel}}</label>
                  <input
                    v-model="vmSubscriptionFormData.parent_mobile"
                    type="text"
                    class="form-control"
                    required/>
                </div>
                <div class="col-md-12 mb-3">
                  <label
                    for="validationparent_email">
                    {{cvParentEmailLabel}}</label>
                  <input
                    v-model="vmSubscriptionFormData.parent_email"
                    type="text"
                    class="form-control"
                    required/>
                </div>
                <div class="col-md-12 mb-3">
                  <label
                    for="validationsubs_collection_method">
                    {{cvamountLabel}}</label>
                  <input
                    v-model="vmSubscriptionFormData.amount"
                    type="text"
                    class="form-control"
                    required/>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationplanId"> {{cvPlanIdLabel}}</label>
                  <multiselect
                    v-model="selectedPlanObj"
                    :options="planIdList"
                    :placeholder="'Select Plan'"
                    label="subs_plan_id"
                    track-by="subs_plan_id"
                  >
                    <span slot="noResult">No plans found</span>
                  </multiselect>
                </div>
              </div>
              <div class="form-group row spinner_add">
                <button v-if="cvLoadingStatus" type="button" class="btn btn-primary float-right" :disabled="cvLoadingStatus">
                  <b-spinner label="Spinning">
                  </b-spinner>
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="sendPaymentSuccess()">
                  {{ cvSubmitBtn }}
                </button>
              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-toast
      v-model="showToast"
      name="Toast"
      :auto-hide-delay="toastVariant === 'danger' ? 10000 : 1000"
      :variant="toastVariant"
      :title="toastTitle">
      <div v-html="toastMsg">
      </div>
    </b-toast>
  </b-container>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import Multiselect from "vue-multiselect"
import userPermission from "../../../Utils/user_permission.js"
import { socialvue } from "../../../config/pluginInit.js"
import { SubscriptionPlans } from "../../../FackApi/api/Subscription/subscriptionPlan.js"
import { PayTransactionss } from "../../../FackApi/api/PayTransactions.js"

export default {
  name: "MissingPaymentsAdd",
  components: {
    Multiselect
  },
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propPaySubsObj: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      selectedPlanObj: null,
      apiName: "subscriptionPlan_list",
      cvCardTitle: "Add Missing Payment",
      cvSubmitBtn: "Add",
      cvNameLabel: "Student Name",
      cvEmailLabel: "Student Email",
      cvSubsMobileLabel: "Mobile Number",
      cvPaytidLabel: "Pay Transaction Id",
      cvOrderIdLabel: "Order id",
      cvParentNameLabel: "Parent Name",
      cvParentmobileLabel: "Parent Mobile",
      cvParentEmailLabel: "Parent Email",
      cvPlanIdLabel: "Plan Id",
      cvamountLabel: "Plan Amount",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      cvLoadingStatus: false,
      toastTitle: "Subscription",
      vmSubscriptionFormData: Object.assign({}, this.initFormData()),
      planIdList: []
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  beforeMount () {
    // Auth Access for Current User Role
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  async mounted () {
    await this.getPlanNames()
    socialvue.index()
    this.initFormData()
  },
  methods: {
    /**
     * onPlanChange
     */
    onPlanChange (selectedId) {
      this.vmSubscriptionFormData.subs_plan_id = selectedId
    },
    /**
     * initFormData
     */
    initFormData () {
      return {
        "user_name": "",
        "user_email": "",
        "user_mobile": "",
        "subs_tid": "",
        "order_id": "",
        "parent_name": "",
        "parent_mobile": "",
        "parent_email": "",
        "amount": "",
        "subs_plan_id": ""
      }
    },
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmSubscriptionFormData) {
          if (!this.vmSubscriptionFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
      }
    },
    async sendPaymentSuccess () {
      try {
        this.cvLoadingStatus = true

        const data = this.vmSubscriptionFormData

        const paymentInsertPayload = {
          user_name: data.user_name,
          user_email: data.user_email,
          user_mobile: data.user_mobile,
          pay_tid: data.subs_tid,
          pay_order_id: data.order_id,
          pay_amount: data.amount * 100, // api accepts amount in paisa
          pay_subs_id: this.selectedPlanObj.subs_plan_id
        }

        // Send to listener API
        const paymentAddResp = await PayTransactionss.razorpay_listeners_insert_payment(this, paymentInsertPayload)

        if (paymentAddResp.status && paymentAddResp.status !== "ok") {
          this.toastVariant = "danger"
          this.toastMsg = paymentAddResp
          this.showToast = true
        }
        else {
          this.toastVariant = "success"
          this.toastMsg = "Payment added successfully"
          this.showToast = true
        }

        this.$emit("emitCloseMissingPayment")
      }
      catch (err) {
        console.error("Exception occurred in sendPaymentSuccess():", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    },
    /**
     * getPlanNames
     */
    async getPlanNames () {
      try {
        const subsPlanListResp = await SubscriptionPlans.subscriptionPlanList(this)
        if (subsPlanListResp.resp_status) {
          this.planIdList = subsPlanListResp.resp_data.data
        }
      }
      catch (err) {
        console.error("Error in getPlanNames ", err)
      }
    }
  }
}
</script>
